import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { Empty } from 'components/Common/Empty'
import { Filters } from 'components/Icons'
import { Common } from 'styles'
import FilterMenuContainer from './filterMenuContainer'

export default connect(
  {
    open: state`media.filter.open`,
    fileTypes: state`media.filter.fileTypes.*`
  },
  class FilterMenu extends Component {
    render() {
      const {
        open,
        fileTypes,
        theme = 'light',
        height = `calc(100% - 15px)`
      } = this.props

      let wrapperWidth = open ? Common.metaMenuWidth : 0

      const content = !fileTypes.length ? (
        <Empty Icon={Filters} translationKey={'bms.media.filterMenu.empty'} />
      ) : (
        <div className={css(styles.container)}>
          <FilterMenuContainer theme={theme} height={height} />
        </div>
      )

      return (
        <div
          style={{ width: wrapperWidth }}
          className={css(styles.motionContainer)}
        >
          {content}
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/FilterMenu/filterMenu.js